import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {viewSelector} from '@mapsight/ui/src/js/store/selectors';

import Logo from '@mapsight/ui/src/js/components/map-overlay/logo';

import {memoForever} from '../../modules/helpers';

import {isViewWithMapWidget} from '../store/selectors';


/** @type {import("@mapsight/ui/src/js/components/contexts").MapOverlayTopRight} */
const MapOverlayBottomLeft = memo(function MapOverlayBottomLeft({children}) {
		const view = useSelector(viewSelector);
		const withLinks = !isViewWithMapWidget(view);

		return withLinks ? (
			<div
				className="ms3-info-overlay__logo"
			>
				<Logo />
			</div>
		) : null;
	},
	memoForever
);

export default MapOverlayBottomLeft;
